/* eslint-disable simple-import-sort/imports */
// import { configureStore, createSlice } from '@reduxjs/toolkit';
// import { v4 as uuidv4 } from 'uuid';

// import predictionsSlice from './apps/2025/store/stateSlice';
// import compatibilityLongSlice from './apps/compatibility-long/store/stateSlice';
// import compatibilityShortSlice from './apps/compatibility-short/store/stateSlice';
// import dateBirthSlice from './apps/date-birth/store/stateSlice';
// import futureSlice from './apps/future/store/stateSlice';
// import messengerSlice from './apps/messenger/store/stateSlice';
// import tarotSlice from './apps/tarot/store/stateSlice';
// import tarotChatSlice from './apps/tarot-chat/store/stateSlice';
// import witchSlice from './apps/witch/store/stateSlice';

// const guestId = createSlice({
//   name: 'guestId',
//   initialState: uuidv4(),
//   reducers: {},
// });

// export const store = configureStore({
//   reducer: {
//     guestId: guestId.reducer,
//     predictions: predictionsSlice,
//     compatibilityLong: compatibilityLongSlice,
//     compatibilityShort: compatibilityShortSlice,
//     dateBirth: dateBirthSlice,
//     messenger: messengerSlice,
//     tarot: tarotSlice,
//     tarotChat: tarotChatSlice,
//     witch: witchSlice,
//     future: futureSlice,
//   },
// });

// export type TRootState = ReturnType<typeof store.getState>;

import { configureStore, createSlice } from '@reduxjs/toolkit';
import { v4 as uuidv4 } from 'uuid';

import { q2025Reducer } from './quizzes/2025/store/q-2025-slice';
import compatibilityLongSlice from './apps/compatibility-long/store/stateSlice';
import compatibilityShortSlice from './apps/compatibility-short/store/stateSlice';
import dateBirthSlice from './apps/date-birth/store/stateSlice';
import futureSlice from './apps/future/store/stateSlice';
import messengerSlice from './apps/messenger/store/stateSlice';
import tarotSlice from './apps/tarot/store/stateSlice';
import tarotChatSlice from './apps/tarot-chat/store/stateSlice';
import witchSlice from './apps/witch/store/stateSlice';

const guestId = createSlice({
  name: 'guestId',
  initialState: uuidv4(),
  reducers: {},
});

export const store = configureStore({
  reducer: {
    guestId: guestId.reducer,
    predictions: q2025Reducer,
    compatibilityLong: compatibilityLongSlice,
    compatibilityShort: compatibilityShortSlice,
    dateBirth: dateBirthSlice,
    messenger: messengerSlice,
    tarot: tarotSlice,
    tarotChat: tarotChatSlice,
    witch: witchSlice,
    future: futureSlice,
  },
});

export type TRootState = ReturnType<typeof store.getState>;
